<template>
  <div>
    <slot />
  </div>
</template>
<style>
@import '@/assets/css/base/index.less';
</style>
